import { useCallback, useEffect } from 'react';
import { IBooking } from '../../../../domain/booking/models/IBooking';
import { useMyBookingsStore } from '../../../../domain/booking/stores/useMyBookingsStore';
import { IGuestBookingFormData } from '../types/IGuestBookingFormData';

interface IOptions {
	onSuccess: (booking: IBooking) => void;
	onError: (error: Error) => void;
}

export function useAddGuestBookingSubmit({ onSuccess, onError }: IOptions) {
	const myBookingsStore = useMyBookingsStore();

	useEffect(() => {
		myBookingsStore.resetGuestBooking();
	}, []);

	const onSubmit = useCallback(
		async (data: IGuestBookingFormData) => {
			try {
				await myBookingsStore.loadGuestBooking(data);
			} catch (e) {
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				onError(e);
			}
		},
		[myBookingsStore],
	);

	useEffect(() => {
		if (myBookingsStore.guestBookingError) {
			onError(myBookingsStore.guestBookingError);
		}
	}, [myBookingsStore.guestBookingError]);

	useEffect(() => {
		if (myBookingsStore.guestBooking) {
			onSuccess(myBookingsStore.guestBooking);
		}
	}, [myBookingsStore.guestBooking]);

	return { onSubmit };
}
